/** @format */

import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";

const RatingTemp = ({ rating, totalRatings, numberRatings }) => {
  return (
    <>
      <div className='flex gap-2 flex-col py-2'>
        {/* Rating Stars */}
        <div className='flex justify-start items-center gap-16'>
          <div className='text-md gap-1 w-[93px]'>
            <div className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
              {/* Filled Stars */}
              {[...Array(rating)].map((_, index) => (
                <span className='text-[#edbb0e]' key={index}>
                  <AiFillStar />
                </span>
              ))}
              {/* Empty Stars */}
              {[...Array(5 - rating)].map((_, index) => (
                <span key={index}>
                  <CiStar />
                </span>
              ))}
            </div>
          </div>
          {/* Rating Bar */}
          <div className='flex gap-5 justify-start items-center'>
            <div className='w-[200px] sm:hidden h-[14px] bg-slate-200 relative'>
              {totalRatings > 0 ? (
                <div
                  className='h-full bg-[#EDBB0E]'
                  style={{ width: `${(numberRatings / totalRatings) * 100}%` }}
                ></div>
              ) : (
                <div className='h-full bg-[#EDBB0E] w-[0%]'></div>
              )}
            </div>
            <p className='text-sm text-slate-600'>{numberRatings}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingTemp;
